import {
	API_DOCS_CONFIRM,
	API_DOCS_LINK,
	IN_DEPTH_REPORT_CONFIRM,
	IN_DEPTH_REPORT_LINK,
	PLANNING_LOOKUP_CONFIRM,
	PLANNING_LOOKUP_LINK
} from '@/constants/planningLookup';

const groupAppsDefault = [
	{
		id: "operation",
		name: "Vận hành",
		apps: [
			{
				id: "workflows",
				type: "item",
				icon: "nav_ycsb",
				title: "Quy trình",
				image: require('@/assets/icons/YCSB.png'),
				routeName: "workflows.user_task",
				customImage: true,
				have_bought: true,
				incomming: false
			},
			// {
			// 	id: "customer",
			// 	type: "item",
			// 	icon: "users",
			// 	title: "Quản lý đối tác",
			// 	image: require('@/assets/icons/QLDT.png'),
			// 	routeName: "customer_group_first.create",
			// 	customImage: false,
			// 	have_bought: true,
			// 	incomming: false,
			// 	dropdown: [
			// 		{
			// 			id: "customer",
			// 			type: "item",
			// 			icon: "users",
			// 			title: "Quản lý đối tác",
			// 			image: require('@/assets/icons/QLDT.png'),
			// 			// routeName: "customer.index",
			// 			dropdown: [
			// 				{
			// 					id: "customer_group_first",
			// 					title: "Phân cấp",
			// 					routeName: "customer_group_first.create",
			// 					exact: true
			// 				},
			// 				{
			// 					id: "customer_group",
			// 					title: "Nhóm đối tác",
			// 					type: "item",
			// 					routeName: "customer.index2",
			// 					exact: true
			// 				},
			// 				{
			// 					id: "customer_private",
			// 					title: "Đối tác",
			// 					type: "item",
			// 					routeName: "customer.index",
			// 					exact: true
			// 				},
			// 			],
			// 			customImage: false
			// 		},
			// 	],
			// },
			{
				id: "tcct",
				type: "item",
				icon: "chart-line",
				title: "Cổng chứng thư",
				image: require('@/assets/icons/TCCT.png'),
				routeName: "certificate_lookup",
				exact: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "manage",
				type: "item",
				icon: "users-cog",
				title: "Cài đặt công ty",
				image: require('@/assets/icons/QLNB.png'),
				routeName: "staff.index",
				exact: true,
				customImage: false,
				have_bought: true,
				incomming: false,
				dropdown: [
					{
						id: "manage",
						type: "item",
						icon: "users-cog",
						title: "Cài đặt công ty",
						image: require('@/assets/icons/QLNB.png'),
						dropdown: [
							{
								id: "staff",
								type: "item",
								title: "Tài khoản",
								routeName: "staff.index",
								exact: true
							},
							{
								id: "role",
								type: "item",
								title: "Phân quyền",
								routeName: "role.index",
								exact: true
							},
							{
								id: "branch",
								title: "Chi nhánh",
								routeName: "branch.index",
								exact: true
							},
							{
								id: "position",
								title: "Chức vụ",
								routeName: "position.index",
								exact: true
							},
							{
								id: "appraiser-company",
								title: "Thông tin công ty",
								routeName: "appraiser-company.index",
								exact: true
							},
							{
								id: "workFlowConfig",
								title: "SLA",
								routeName: "pre_certificate_config.index",
								exact: true
							},
							{
								id: "working-hours",
								title: "Thời gian làm việc",
								routeName: "working_hours.index",
								exact: true
							},
							{
								id: "bank-account",
								title: "Tài khoản ngân hàng",
								routeName: "bank_account.index",
								exact: true
							}
						],
						exact: true,
						customImage: false
					},
				],
			},
			{
				id: "digital_signature_requests",
				type: "item",
				icon: "file-signature",
				title: "Yêu cầu ký số",
				image: require('@/assets/icons/CSM.png'),
				routeName: "profile.digital_signature_requests",
				have_bought: true,
				incomming: false,
			},
			{
				id: "digital_signature_history",
				type: "item",
				icon: "history",
				title: "Lịch sử ký số",
				image: require('@/assets/icons/QLDT.png'),
				routeName: "profile.digital_signature_history",
				have_bought: true,
				incomming: false,
			},
		]
	},
	{
		id: "business",
		name: "Nghiệp vụ",
		apps: [
			{
				id: "certification_asset",
				type: "item",
				icon: "nav_tstd",
				title: "Thẩm định tài sản",
				image: require('@/assets/icons/TSTD.png'),
				routeName: "certification_asset.index",
				customImage: true,
				have_bought: true,
				incomming: false,
				dropdown: [
					{
						id: "certification_asset",
						type: "item",
						icon: "nav_tstd",
						title: "Thẩm định tài sản",
						image: require('@/assets/icons/TSTD.png'),
						dropdown: [
							{
								id: "real_estate",
								title: "Bất động sản",
								routeName: "certification_asset.index",
								exact: true
							},
							{
								id: "personal_property",
								title: "Động sản",
								routeName: "certification_personal_property.index",
								exact: true
							},
							{
								id: "personal_property_old",
								title: "Động sản cũ",
								routeName: "certification_personal_property_old.index",
								exact: true,
								denied: process.env.CLIENT_ENV !== 'viettin' ? ['*'] : []
							}
						],
						customImage: true
					},
				],
			},
			{
				id: "warehouse",
				type: "item",
				icon: "nav_kg",
				title: "Tài sản so sánh",
				image: require('@/assets/icons/TSSS.png'),
				routeName: "warehouse.index",
				customImage: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "price_estimates",
				type: "item",
				icon: "nav_utg",
				title: "Định giá sơ bộ",
				image: require('@/assets/icons/TSSB.png'),
				routeName: "price_estimates.index",
				customImage: true,
				have_bought: true,
				incomming: false
			},
			{
				id: "appraise",
				type: "item",
				icon: "nav_dltd",
				title: "Cài đặt nghiệp vụ",
				image: require('@/assets/icons/QLDL.png'),
				routeName: "appraise-law.index",
				customImage: true,
				have_bought: true,
				incomming: false,
				dropdown: [
					{
						id: "appraise",
						type: "item",
						icon: "nav_dltd",
						title: "Cài đặt nghiệp vụ",
						image: require('@/assets/icons/QLDL.png'),
						dropdown: [
							{
								id: "appraise-law",
								title: "Văn bản pháp luật",
								routeName: "appraise-law.index",
								exact: true
							},
							{
								id: "appraise-other",
								title: "Cơ sở thẩm định",
								routeName: "appraise-other.index",
								exact: true
							},
							{
								id: "appraisal-construction",
								title: "Công ty xây dựng",
								routeName: "appraisal-construction.index",
								exact: true
							},
							{
								id: "building",
								title: "Loại công trình",
								routeName: "building.index",
								exact: true
							},
							{
								id: "element",
								title: "Yếu tố so sánh",
								routeName: "element.index",
								exact: true
							},
							{
								id: "dictionary",
								title: "Đặc điểm tài sản",
								routeName: "dictionary.index",
								exact: true
							},
							{
								id: "province",
								title: "Tỉnh/Thành",
								routeName: "province.index",
								exact: true
							},
							{
								id: "district",
								title: "Quận/Huyện",
								routeName: "district.index",
								exact: true
							},
							{
								id: "ward",
								title: "Phường/Xã",
								routeName: "ward.index",
								exact: true
							},
							{
								id: "street",
								title: "Đường phố",
								routeName: "street.index",
								exact: true
							},
							{
								id: "distance",
								title: "Đoạn đường",
								routeName: "distance.index",
								exact: true
							},
							{
								id: "apartment",
								title: "Chung cư",
								routeName: "apartment.index",
								exact: true
							}
						],
						customImage: true
					},
				],
			},
		]
	},
	{
		id: "utilities",
		name: "Tiện ích",
		apps: [
			{
				id: "map",
				type: "item",
				icon: "nav_bdg",
				title: "Bản đồ giá",
				image: require('@/assets/icons/BDG.png'),
				routeName: "map.index",
				exact: true,
				customImage: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "quyhoach",
				type: "item",
				icon: "nav_bddc",
				title: "Tra quy hoạch",
				image: require('@/assets/icons/TCQH.png'),
				externalLink: PLANNING_LOOKUP_LINK,
				confirmMessage: PLANNING_LOOKUP_CONFIRM,
				customImage: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "api_connection",
				type: "item",
				icon: "nav_bddc",
				title: "Kết nối API",
				image: require('@/assets/icons/HSTD.png'),
				externalLink: API_DOCS_LINK,
				confirmMessage: API_DOCS_CONFIRM,
				customImage: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "in_depth_report",
				type: "item",
				icon: "nav_bddc",
				title: "Báo cáo chuyên sâu",
				image: require('@/assets/icons/TCQH.png'),
				externalLink: IN_DEPTH_REPORT_LINK,
				confirmMessage: IN_DEPTH_REPORT_CONFIRM,
				customImage: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "tttt",
				type: "item",
				icon: "nav_bdg",
				title: "Thị trường",
				image: require('@/assets/icons/TTTT_incomming.png'),
				routeName: "map.index",
				exact: true,
				customImage: true,
				have_bought: true,
				incomming: true,
			},
		]
	},
	{
		id: "analyst",
		name: "Analyst",
		apps: [
			// {
			// 	id: "finance",
			// 	type: "item",
			// 	icon: "chart-line",
			// 	title: "Công cụ tài chính",
			// 	image: require('@/assets/icons/financial-tools.png'),
			// 	routeName: "finance.index",
			// 	exact: true,
			// 	have_bought: true,
			// 	incomming: false,
			// },
			{
				id: "dashboard",
				type: "item",
				icon: "chart-line",
				title: "Báo cáo quản trị",
				image: require('@/assets/icons/BCQT.png'),
				routeName: "dashboard.index",
				exact: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "dashboard_legacy",
				type: "item",
				icon: "chart-line",
				title: "Báo cáo quản trị cũ",
				image: require('@/assets/icons/BCQT.png'),
				routeName: "dashboard.legacy",
				exact: true,
				have_bought: true,
				incomming: false,
			},
			{
				id: "certification_brief",
				type: "item",
				icon: "nav_hstd",
				title: "Hồ sơ thẩm định",
				image: require('@/assets/icons/HSTD.png'),
				routeName: "certification_brief.index",
				customImage: true,
				have_bought: true,
				incomming: false
			},
			{
				id: "pre_certification",
				type: "item",
				icon: "nav_hstd",
				title: "Yêu cầu sơ bộ",
				image: require('@/assets/icons/YCSB.png'),
				routeName: "pre_certification.index",
				customImage: true,
				have_bought: true,
				incomming: false
			},
		]
	}
];

const fallbackDefaultAppConfig = [
	{ group: 'operation', id: 'workflows' },
	{ group: 'business', id: 'certification_asset' },
	{ group: 'utilities', id: 'map' },
	{ group: 'utilities', id: 'quyhoach' },
	{ group: 'utilities', id: 'api_connection' },
	{ group: 'operation', id: 'tcct' },
];

const ALWAYS_HIDDEN_APP_IDS = ['finance'];

const parseArrayEnv = (value) => {
	if (Array.isArray(value)) {
		return value;
	}
	if (typeof value === 'string') {
		try {
			const parsed = JSON.parse(value);
			return Array.isArray(parsed) ? parsed : null;
		} catch (error) {
			return null;
		}
	}
	return null;
};

const parseBooleanEnv = (value, defaultValue = false) => {
	if (typeof value === 'boolean') {
		return value;
	}
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		if (normalized === 'true') {
			return true;
		}
		if (normalized === 'false') {
			return false;
		}
	}
	return defaultValue;
};

const parseObjectEnv = (value) => {
	if (value && typeof value === 'object' && !Array.isArray(value)) {
		return value;
	}
	if (typeof value === 'string') {
		try {
			const parsed = JSON.parse(value);
			if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
				return parsed;
			}
		} catch (error) {
			return null;
		}
	}
	return null;
};

const appendGroupAppChild = (childrenConfig, groupId, appId, shouldAppend) => {
	if (!shouldAppend) {
		return childrenConfig;
	}

	const nextConfig = childrenConfig && typeof childrenConfig === 'object' && !Array.isArray(childrenConfig)
		? { ...childrenConfig }
		: {};
	const groupChildren = Array.isArray(nextConfig[groupId])
		? [...nextConfig[groupId]]
		: [];

	if (!groupChildren.includes(appId)) {
		groupChildren.push(appId);
	}

	nextConfig[groupId] = groupChildren;
	return nextConfig;
};

const buildWorkflowShortcutId = (workflowId) => `workflow-shortcut-${workflowId}`;

const normalizeWorkflowShortcuts = (value) => {
	const parsed = parseArrayEnv(value);
	if (!Array.isArray(parsed)) {
		return [];
	}

	return parsed
		.map((item) => {
			if (!item || typeof item !== 'object') {
				return null;
			}

			const workflowId = String(
				item.workflowId ?? item.workflow_id ?? item.id ?? ''
			).trim();
			const title = String(item.title ?? item.name ?? '').trim();

			if (!workflowId || !title) {
				return null;
			}

			return {
				id: buildWorkflowShortcutId(workflowId),
				type: 'item',
				icon: item.icon || 'nav_ycsb',
				title,
				image: require('@/assets/icons/YCSB.png'),
				routeName: 'workflows.detail',
				routeQuery: {
					id: workflowId,
					name: title,
					...(item.routeQuery && typeof item.routeQuery === 'object' ? item.routeQuery : {}),
				},
				routeParams: item.routeParams && typeof item.routeParams === 'object' ? item.routeParams : {},
				customImage: true,
				have_bought: item.have_bought ?? true,
				incomming: item.incomming ?? false,
			};
		})
		.filter(Boolean);
};

const cloneAppNode = (node) => {
	const cloned = { ...node };
	if (Array.isArray(node.dropdown)) {
		const dropdownClone = node.dropdown.map((child) => cloneAppNode(child));
		if (dropdownClone.length > 0) {
			cloned.dropdown = dropdownClone;
		}
	}
	return cloned;
};

const filterAppNodes = (nodes, allowedIds, hiddenIdsSet) => {
	if (!Array.isArray(nodes)) {
		return [];
	}
	return nodes
		.filter((item) => {
			if (hiddenIdsSet && hiddenIdsSet.has(item.id)) {
				return false;
			}
			return !allowedIds || allowedIds.includes(item.id);
		})
		.map((item) => {
			const cloned = { ...item };
			if (Array.isArray(item.dropdown)) {
				const filteredDropdown = filterAppNodes(item.dropdown, allowedIds, hiddenIdsSet);
				if (filteredDropdown.length > 0) {
					cloned.dropdown = filteredDropdown;
				} else {
					delete cloned.dropdown;
				}
			}
			return cloned;
		});
};

const findAppInNodes = (nodes, appId) => {
	if (!Array.isArray(nodes)) {
		return null;
	}
	for (const node of nodes) {
		if (node.id === appId) {
			return node;
		}
		if (Array.isArray(node.dropdown)) {
			const found = findAppInNodes(node.dropdown, appId);
			if (found) {
				return found;
			}
		}
	}
	return null;
};

const resolveAppFromGroups = (groups, groupId, appId) => {
	const targets = groupId ? groups.filter((group) => group.id === groupId) : groups;
	for (const group of targets) {
		const found = findAppInNodes(group.apps, appId);
		if (found) {
			return cloneAppNode(found);
		}
	}
	return null;
};

const applyHaveBoughtOverrides = (nodes, boughtMap, allowedBoughtSet) => {
	if (!Array.isArray(nodes)) {
		return [];
	}
	return nodes.map((node) => {
		const cloned = { ...node };
		if (
			boughtMap &&
			Object.prototype.hasOwnProperty.call(boughtMap, cloned.id)
		) {
			cloned.have_bought = !!boughtMap[cloned.id];
		} else if (allowedBoughtSet instanceof Set) {
			cloned.have_bought = allowedBoughtSet.has(cloned.id);
		}
		if (Array.isArray(node.dropdown)) {
			const dropdownClone = applyHaveBoughtOverrides(
				node.dropdown,
				boughtMap,
				allowedBoughtSet
			);
			if (dropdownClone.length > 0) {
				cloned.dropdown = dropdownClone;
			}
		}
		return cloned;
	});
};

const buildGroupApps = (
	groups,
	allowedGroupIds,
	allowedChildrenMap,
	boughtMap,
	showAllApps,
	hiddenIdsSet,
	workflowShortcutApps = []
) => {
	const baseGroups = Array.isArray(allowedGroupIds) && allowedGroupIds.length > 0
		? groups.filter((group) => allowedGroupIds.includes(group.id))
		: groups;

	return baseGroups.map((group) => {
		const configuredChildren = Array.isArray(allowedChildrenMap && allowedChildrenMap[group.id])
			? [...allowedChildrenMap[group.id]]
			: null;
		const groupApps = group.id === 'operation' && workflowShortcutApps.length > 0
			? (() => {
				const operationApps = [...group.apps];
				const insertIndex = operationApps.findIndex((item) => item.id === 'workflows');
				if (insertIndex === -1) {
					return [...workflowShortcutApps, ...operationApps];
				}
				operationApps.splice(insertIndex + 1, 0, ...workflowShortcutApps);
				return operationApps;
			})()
			: group.apps;
		if (configuredChildren && group.id === 'operation' && workflowShortcutApps.length > 0) {
			workflowShortcutApps.forEach((shortcut) => {
				if (!configuredChildren.includes(shortcut.id)) {
					configuredChildren.push(shortcut.id);
				}
			});
		}
		const allowedChildren = !showAllApps ? configuredChildren : null;
		const allowedBoughtSet = showAllApps && Array.isArray(configuredChildren)
			? new Set(configuredChildren)
			: null;
		const filteredApps = filterAppNodes(groupApps, allowedChildren, hiddenIdsSet);
		return {
			...group,
			apps: applyHaveBoughtOverrides(filteredApps, boughtMap, allowedBoughtSet),
		};
	});
};

const buildDefaultApps = (groups, configEntries, fallbackEntries) => {
	const entries = Array.isArray(configEntries) && configEntries.length > 0 ? configEntries : fallbackEntries;
	const resolved = [];
	const seen = new Set();
	entries.forEach((entry) => {
		if (!entry) {
			return;
		}
		let groupId;
		let appId;
		if (typeof entry === 'string') {
			appId = entry;
		} else if (typeof entry === 'object') {
			appId = entry.id || entry.appId;
			groupId = entry.group || entry.groupId;
		}
		if (!appId) {
			return;
		}
		const key = `${groupId || ''}:${appId}`;
		if (seen.has(key)) {
			return;
		}
		const app = resolveAppFromGroups(groups, groupId, appId);
		if (app) {
			resolved.push(app);
			seen.add(key);
		}
	});
	return resolved;
};

const envDefaultAppsConfig = parseArrayEnv(process.env.default_apps);
const envGroupIds = parseArrayEnv(process.env.group_apps);
const envChildrenConfig = parseObjectEnv(process.env.group_app_children);
const envBoughtConfig = parseObjectEnv(process.env.group_app_bought);
const envShowAllApps = parseBooleanEnv(process.env.show_all_group_apps, true);
const envHiddenApps = parseArrayEnv(process.env.hidden_apps);
const envShowCertificationBriefApp = parseBooleanEnv(process.env.show_certification_brief_app, false);
const effectiveChildrenConfig = appendGroupAppChild(
	envChildrenConfig,
	'analyst',
	'certification_brief',
	envShowCertificationBriefApp
);
const workflowShortcutApps = normalizeWorkflowShortcuts(process.env.workflow_shortcuts);
const hiddenAppIdsSet = new Set([
	...ALWAYS_HIDDEN_APP_IDS,
	...(!envShowCertificationBriefApp ? ['certification_brief'] : []),
	...(Array.isArray(envHiddenApps) ? envHiddenApps : []),
]);

const groupApps = buildGroupApps(
	groupAppsDefault,
	envGroupIds,
	effectiveChildrenConfig || {},
	envBoughtConfig || {},
	envShowAllApps,
	hiddenAppIdsSet,
	workflowShortcutApps
);
const defaultApps = [...workflowShortcutApps, ...buildDefaultApps(groupApps, envDefaultAppsConfig, fallbackDefaultAppConfig)]
	.filter((app, index, apps) => app && apps.findIndex((candidate) => candidate.id === app.id) === index);

export { groupAppsDefault, groupApps, defaultApps };
